module.exports = __webpack_public_path__ + "img/MaureenBurgess_crop50.e829644a.png";